import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <h2>Amar Clicks</h2>
                <p>Capturing moments, creating memories.</p>

                <div className="social-links">
                    <a href="https://www.instagram.com/mvghall?igsh=OG14ZjFvdnowcWNo" target="_blank" rel="noopener noreferrer">Instagram</a>
                    <a href="https://www.instagram.com/mvghall?igsh=OG14ZjFvdnowcWNo" target="_blank" rel="noopener noreferrer">Facebook</a>
                    <a href="mailto:ammarmaroof447@gmail.com">Email</a>
                </div>

                <div className="footer-links">
                    <a href="/portfolio">Portfolio</a>
                    <a href="/services">Services</a>
                    <a href="/contact">Contact</a>
                    <a href="/privacy-policy">Privacy Policy</a>
                </div>

                <div className="alpha-tech-credit">
                    <p>Developed & Maintained by <strong>AlphaTech</strong></p>
                    <a href="https://alphatechitco.netlify.app/" target="_blank" rel="noopener noreferrer">Visit AlphaTech</a>
                </div>

                <p className="copyright">© {new Date().getFullYear()} Amar Clicks. All rights reserved.</p>
            </div>
        </footer>
    );
}

export default Footer;
